var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":"https://ljtc.tcrc.com.cn/webroot/decision/view/report?viewlet=assist_out.cpt&ref_t=design&op=view","id":"mobsf","width":"100%","height":"100%","scrolling":"no","frameborder":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }